import { TokenService } from './../token.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import {NgbDate, NgbCalendar, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateAdapter, NgbDateNativeAdapter} from '@ng-bootstrap/ng-bootstrap';

import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ModalSelecaoDBEComponent } from '../shared/modal/modal-selecao-dbe/modal-selecao-dbe.component';
import { ServicosGeraisService } from '../services/servicos-gerais.service';
import { ErrorService } from '../services/error.service';
import { ModalInformativoJucespComponent } from '../shared/modal/modal-informativo-jucesp/modal-informativo-jucesp.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}],
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {

  localExibicao: any;
  tipoPortal: any;
  dados: any

  loginAuth: string;

  hoveredDate: NgbDate;
  fromDate: NgbDate;
  toDate: NgbDate;
  currentDay = new Date();
  dataExtenso: any;
  navigation: any;
  //onDateSelection: any;
  onDateSelection: () => any;
  // convertDataExtenso: any;
  // linkViabilidade: any;
  // dayWeek: any;

  constructor(
    private calendar: NgbCalendar,
    private route: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
    private modalService: NgbModal,
    private service: ServicosGeraisService,
    private errorService: ErrorService,
    ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  isWeekend = (date: NgbDate) =>  this.calendar.getWeekday(date) === 7 || this.calendar.getWeekday(date) === 6;

  ngOnInit() {

    this.route.queryParams.subscribe(
      (queryParams: any) => {
        if (queryParams['tkLogin']) {
          sessionStorage.setItem('loginAuth', queryParams['tkLogin']);
        }
      }
    );

    this.loginAuth = sessionStorage.getItem('loginAuth');

    this.validaToken(this.loginAuth);

    if (!$('.li-seta').hasClass('ativo')) { //FECHA O SIDE
      $('.li-seta').removeClass('ativo');
      $('.content-inner').animate({ paddingLeft: '6.8rem' });
      $('.navbar-minimal.open').css('width', '80px');
      $('.fa-angle-double-left').addClass('fa-angle-double-right');
      $('.fa-angle-double-left').removeClass('fa-angle-double-left');
      $('li a span').addClass('desc');
      $('li a').removeClass('text-right');
      $('li a').addClass('text-center');
      $('li a span').css('margin', '-20px 0 0 35px');
      $('.nomeExpandir').html(' Expandir Menu ');
    } else { //ABRE O SIDE
      $('.li-seta').addClass('ativo');
      $('.content-inner').animate({ paddingLeft: '18rem' });
      $('.navbar-minimal.open').css('width', '260px');
      $('.fa-angle-double-right').addClass('fa-angle-double-left');
      $('.fa-angle-double-right').removeClass('fa-angle-double-right');
      $('li a span').removeClass('desc');
      $('li a').removeClass('text-center');
      $('li a').addClass('text-right');
      $('li a span').css('margin', '10px');
      $('li a i').css('width', '20px');
      $('.nomeExpandir').html(' Recolher Menu ');
    }

    this.dataExtenso = this.convertDataExtenso();

}

ngAfterViewInit(){
  // carrega o serviço do comunicado após setar o token na sessionStorage
  this.loadComunicado();
}

loadComunicado() {
  this.localExibicao = "AREA_LOGADA";
  this.tipoPortal = "INTEGRADOR"
  this.service.getComunicado(this.localExibicao,this.tipoPortal)
  .then((res) => {
    if(res != ""){
      this.dados = JSON.parse(res);
      if (this.dados.statusComunicado == 'ATIVO') {
        this.openModalComunicado(this.dados);
      }
    }
  }).catch((erro) => {
    this.errorService.error(erro);
  });
}

openModalComunicado(dados: any) {
  const modal = this.modalService.open(ModalInformativoJucespComponent, {
    size: 'lg',
    centered: true,
    keyboard: false,
    backdrop: 'static'
  });
  modal.componentInstance.dados = this.dados;
}

validaToken(token: any) {
  this.tokenService
    .validaToken(token)
    .then(data => {
      if (typeof data !== 'undefined' && typeof data.cpf !== 'undefined') {
        this.redirectToken(true);
      } else {
        if (environment.mockToken) {
          this.redirectToken(true);
        } else {
          this.redirectToken(false);
        }
      }
    })
    .catch(error => {
      if (environment.mockToken) {
        this.redirectToken(true);
      } else {
        this.redirectToken(false);
      }
    });
}

redirectToken(tkAtivo: boolean) {
  if (tkAtivo) {
    this.router.navigate(['/dashboard']);
  } else {
    // PARA LOGAR SEM TOKEN
    if (environment.mockToken) {
      this.router.navigate(['/dashboard']);
    } else {
      // PARA LOGAR COM TOKEN
      if (window.location.href.indexOf('/login') == -1) {
        window.location.href = environment.baseURL;
      }
    }
  }
}

linkViabilidade() {
  window.location.href = environment.linkViabilidade + this.loginAuth;
}

linkInscricaoMunicipal() {
  window.location.href = environment.linkInscricaoMunicipal + this.loginAuth;
}

linkLicenciamento() {
  window.location.href = environment.linkLicenciamento + this.loginAuth;
}

linkBalcaoUnico(){
  window.location.href = environment.linkBalcaoUnico + this.loginAuth;
}

public linkCPFBloqueado(event){
  window.location.href =  environment.linkCPFBloqueado + this.loginAuth;
}

convertDataExtenso() {
  const dateFull = new Date().toDateString().split(" ");
  return `${this.dayWeek(dateFull[0])}, ${dateFull[2]} de ${this.monthString(dateFull[1])} de ${dateFull[3]}`;
}

dayWeek(day) {
  if (day == "Sun") return "Domingo";
  if (day == "Mon") return "Segunda";
  if (day == "Tue") return "Terça-feira";
  if (day == "Wed") return "Quarta-feira";
  if (day == "Thu") return "Quinta-feira";
  if (day == "Fri") return "Sexta-feira";
  if (day == "Sat") return "Sábado";
}

monthString(month) {
  if (month == "Jan") return "Janeiro";
  if (month == "Fab") return "Fevereiro";
  if (month == "Mar") return "Março";
  if (month == "Apr") return "Abril";
  if (month == "May") return "Maio";
  if (month == "Jun") return "Junho";
  if (month == "Jul") return "Julho";
  if (month == "Aug") return "Agosto";
  if (month == "Sep") return "Setembro";
  if (month == "Oct") return "Outubro";
  if (month == "Nov") return "Novembro";
  if (month == "Dec") return "December";
}

openModalDBE() {

  this.modalService.open(ModalSelecaoDBEComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
}

}
